import { IPaginationDTO, ICastCrewDTO, ISubmissionCastCrewDTO } from '@/dtos';
import { generatePagination, get, post } from './apiWrapper';

export const getAllCastAndCrewSettingsAPI = async (
  pagination?: IPaginationDTO,
): Promise<{ data: ICastCrewDTO[]; count: number }> => {
  let pageOptions = '';
  if (pagination) {
    pageOptions = await generatePagination(pagination);
  }

  const admins = await get<{ data: ICastCrewDTO[]; count: number }>(
    `/settings/castandcrew${pageOptions}`,
  );
  return admins;
};

export const getCastAndCrewAPI = async (
  submissionId: string,
  pagination?: IPaginationDTO,
): Promise<{ data: ICastCrewDTO[]; count: number }> => {
  let pageOptions = '';
  if (pagination) {
    pageOptions = await generatePagination(pagination);
  }

  const admins = await get<{ data: ICastCrewDTO[]; count: number }>(
    `/submission/${submissionId}/castandcrew${pageOptions}`,
  );
  return admins;
};

export const updateCastAndCrewAPI = async (
  submissionId: string,
  castAndCrew: ISubmissionCastCrewDTO[],
): Promise<boolean> => {
  await post<boolean>(`/submission/${submissionId}/castandcrew`, castAndCrew);
  return true;
};

export const saveCastCrewAPI = async (castAndCrew: ISubmissionCastCrewDTO): Promise<boolean> => {
  await post<boolean>(`/submission/castandcrew`, castAndCrew);
  return true;
};

export const updateTalenReleaseAPI = async (
  castAndCrew: ISubmissionCastCrewDTO,
): Promise<boolean> => {
  await post<boolean>(`/submission/castandcrew/talent`, castAndCrew);
  return true;
};
